import {Message} from 'element-ui'
export default {
    install (Vue) {
      // 防止重复点击
      
      Vue.directive('preventClick', {
        inserted (el, binding) {
         let bool=true
         let count=0
         el.addEventListener('click', async() => {     
            // if (!el.disabled) {
            //    el.disabled = true
            //    setTimeout(() => {
            //     el.disabled = false
            //     Message({
            //       message: "请勿重复点击",
            //       type: "warning",
            //       duration: 5000,
            //       offset: 150,
            //       showClose: true
            //     });
            //   }, 5000)
            // }   
              count++
              if(count>1){
                Message({
                  message:"请勿连续重复操作", type:"warning",
                  duration:5000,offset:150,showClose:true
                });
              }
              // console.log(count,"count",bool)
              if(bool==true){
                 bool=false;
                 binding.value();
              }
              setTimeout(()=>{
                  bool=true; count=0;
              },5000)
          })
        }
      })
    }
  }


// WEBPACK FOOTER //
// ./src/utils/clickStatefrom.js